import '../scss/style.scss';
import '../../node_modules/@splidejs/splide/dist/css/splide-core.min.css';

import navigation from './scripts/navigation';
import heroCarousel from './scripts/hero-carousel';
import events from './scripts/events';
import testimonials from './scripts/testimonials';
import faq from './scripts/faq';

if(document.readyState !== 'loading') {
	runOnStart();
}
else {
	document.addEventListener('DOMContentLoaded', function () {
			runOnStart()
	});
}

function runOnStart() {
	// Run your code here
	navigation();
	heroCarousel();
	testimonials();
	faq();
	events();
}